import React from 'react'
import * as rb from 'react-bootstrap'

interface Props {
  id: string
  title: string
  visible: boolean
  onHideHandler: () => void
}

export const GenericModal: React.FC<Props> = ({id, title, children, visible, onHideHandler}) => {
  const handleModalToggle = () => {
    onHideHandler()
  }

  return (
    <rb.Modal
      dialogClassName={id}
      className={'dialog-modal'}
      show={visible}
      centered
      onHide={handleModalToggle}
    >
      <rb.Modal.Header closeButton>
        <rb.Modal.Title>
          <div className='row'>
            <div className='col-lg-2 flex-center'>
              <i className='bi bi-exclamation-triangle-fill text-danger fs-2x'></i>
            </div>
            <div className='col-lg-10 flex-center'>{title}</div>
          </div>
        </rb.Modal.Title>
      </rb.Modal.Header>
      <rb.Modal.Body className={'pre-wrap'}>
        <div className='row mb-6'>
          <div className='col-lg-12 flex-center'>{children}</div>
        </div>
      </rb.Modal.Body>
      <rb.Modal.Footer>
        <rb.Button variant='primary btn-block' onClick={handleModalToggle}>
          Close
        </rb.Button>
      </rb.Modal.Footer>
    </rb.Modal>
  )
}
